<template>
  <div>
    <DxDataGrid
      :data-source="adUsers"
      :show-borders="true"
      :column-auto-width="true"
      :row-alternation-enabled="true"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :remote-operations="false"
      :filter-row="{ visible: true, applyFilter: 'auto' }"
      :header-filter="{ visible: true }"
      height="600px"
    >
      <DxPaging :page-size="10" />
      <DxPager :show-page-size-selector="true" :allowed-page-sizes="[5,10,20]" show-info />

      <DxColumn data-field="samAccountName" caption="Username" :allowSorting="true" />
      <DxColumn data-field="displayName" caption="Nume complet" :allowSorting="true" />
      <DxColumn data-field="email" caption="Email" :allowSorting="true" />

      <!-- Are Cont -->
      <DxColumn data-field="AreCont" caption="Are Cont" cell-template="accountCell" :allow-sorting="true" />

      <!-- Template pentru Are Cont -->
      <template #accountCell="{ data }">
        <div>
          <DxButton
            v-if="!data.value"
            text="Generează cont"
            type="success"
            stylingMode="contained"
            @click="generateAccount(data.data)"
          />
          <DxButton
            v-else
            text="Are cont"
            type="danger"
            stylingMode="contained"
            disabled
          />
        </div>
      </template>
    </DxDataGrid>

    <div v-if="loading" class="text-center py-6">
      <v-progress-circular indeterminate :color="APP_Color"></v-progress-circular>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import ADServices from "@/services/AUTH/AD_Services";
import AppSettings from "@/settings/appSettings";
import DxDataGrid, { DxColumn, DxPaging, DxPager } from "devextreme-vue/data-grid";
import DxButton from "devextreme-vue/button";

interface ADUser {
  samAccountName: string;
  displayName: string;
  email: string;
  enabled: boolean;
  AreCont: boolean;
}

export default defineComponent({
  name: "ADTab",
  components: { DxDataGrid, DxColumn, DxPaging, DxPager, DxButton },
  setup() {
    const adUsers = ref<ADUser[]>([]);
    const loading = ref(false);
    const APP_Color = AppSettings.APP_Color;

    const fetchUsers = async () => {
      loading.value = true;
      try {
        const response = await ADServices.getUsers();
        adUsers.value = response.data.map((u: any) => ({
          samAccountName: u.SamAccountName,
          displayName: u.DisplayName,
          email: u.Email,
          AreCont: u.AreCont
        }));
      } catch (err) {
        console.error(err);
      } finally {
        loading.value = false;
      }
    };

    const generateAccount = async (user: ADUser) => {
      try {
        loading.value = true;
        const response = await ADServices.generateAccount(user.email, user.samAccountName);
        user.AreCont = true;
      } catch (err) {
        console.error("Eroare la generarea contului:", err);
      } finally {
        loading.value = false;
      }
    };

    onMounted(fetchUsers);

    return { adUsers, loading, APP_Color, generateAccount };
  }
});
</script>

<style scoped>
</style>
